/**
 * Toggle FAQ questions
 */
$(function () {
    var section = $('.hindle-faqs');

    if (section.length === 0) {
        return;
    }

    var questions = section.find('.question');
    var answers = section.find('.answer');
    var hidden = '-hidden';

    questions.each(function (index, element) {
        var question = $(element);
        var answer = question.next('.answer');
        var link = $('<a href="#"></a>');

        // Replace question content with link with same content
        link.html(question.html());
        question.empty().append(link);

        link.on('click', function (e) {
            e.preventDefault();

            // Hide the other answers
            questions.not(question).addClass(hidden);
            answers.not(answer).slideUp();

            // Toggle this answer and toggle the appropriate question class
            answer.slideToggle().promise().done(function () {
                question.toggleClass(hidden, !answer.is(':visible'));
            });
        });
    });

    // Hide all answers on page load
    questions.addClass(hidden);
    answers.hide();
});
